export const apiConfig = {
  gql: {
    url: 'https://poc-api-irdai.klefki.io.klefki.io/scooby-gql/',
  },
  rest: {
    url: 'https://poc-api-irdai.klefki.io.klefki.io/scooby-iam',
  },
  sendOTPEP: '/user/sign-up',
  SignInUserEP: '/user/sign-in',
  signInTypeEP: '/user/sign-in-type/get',
  accessTokenEP: '/user/access-token/get',
  signInEP: '/user/sign-in',
  baseURL:
    'https://pooja-dev-dc.vlinder.io/cognizant-scooby-rest/payment-gateway/success',
  scriptURL: 'https://checkout.razorpay.com/v1/checkout.js',
  keyId: 'rzp_test_zMlQ6S29QkhjEK',
};
